// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"898":"1daff812","901":"7ae7a135"}[chunkId] + ".chunk.js";
};